// extracted by mini-css-extract-plugin
export default {"container":"Jna-z","heading":"Kna-z","links":"Lna-z","linkBtn":"Mna-z","disabled":"Nna-z","linkUppercaseBold":"Ona-z","copy":"Pna-z","subCopy":"Qna-z"};